import React from "react";
import { images } from "../assets";
const SImage = (props) => {
  const { src } = props;

  return <img className="w-full h-full"  {...props} src={src || images.logoPNG} alt=""  />;
};

export default SImage;
